export default {
  init() {
    // JavaScript to be fired on the home page
    const earlSection = document.querySelector('.section--1 .container')

    // Add Earl Nixon container
    // NOTE: Don't want to deal with doing this with ACF / PHP
    if (earlSection) {
      const earlContainer = document.createElement('div')

      earlContainer.classList.add('section__earl')

      earlSection.append(earlContainer)
    }

    // Handle random home gallery carousel
    if ($('.gallery').length) {
      if (window.matchMedia('(max-width: 1023px)').matches) {
        $('.gallery').slick({
          accessibility: true,
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 10000,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        })
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js